<template>
  <section id="headerMenu">
    <el-tabs :value="curFirstMenu" @tab-click="tabClick">
      <el-tab-pane v-for="item in menuList" :key="item.id" :label="item.name" :name="item.id"></el-tab-pane>
    </el-tabs>
  </section>
</template>
<script>
import { mapState, mapMutations, mapGetters } from 'vuex'

export default {
  name: 'HeaderMenu',
  computed: {
    ...mapState('menu', ['curFirstMenu', 'menuList']),
    ...mapGetters('menu', ['secondMenuList',])
  },
  methods: {
    ...mapMutations('menu', ['setCurFirstMenu', 'setCurSecondMenu']),
    tabClick(item) {
      this.setCurFirstMenu(item.name)
      setTimeout(() => {
        this.setCurSecondMenu(this.secondMenuList[0].id)
        this.$router.push({ path: '/eipManage/' + this.secondMenuList[0].alias })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/config.scss';

#headerMenu {
  user-select: none;
  :deep(.el-tabs) {
    .el-tabs__header {
      margin-bottom: 0;
    }
    .el-tabs__nav-wrap {
      padding: 0 24px;
      margin-bottom: 0;
      &:after {
        display: none;
      }
    }
    .el-tabs__content {
      display: none;
    }
    .el-tabs__active-bar {
      display: none;
    }
    .el-tabs__nav-prev,
    .el-tabs__nav-next {
      line-height: $header-height;
      color: #fff;
      font-size: 24px;
    }
    .el-tabs__item {
      padding: 0 20px;
      height: $header-height;
      line-height: $header-height;
      border-bottom: none;
      color: #fff;
      font-size: 18px;
      & + .el-tabs__item {
        margin-left: 35px;
      }
      &.is-active {
        background-color: #2a54be !important;
      }
      &:hover {
        background-color: #2a54be !important;
      }
    }
  }
}
</style>
